import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function PrivacidadePage() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main className="pt-20">
        <section className="bg-white py-24">
          <div className="max-w-4xl mx-auto px-6 lg:px-12">
            <div className="mb-12">
              <Link
                to="/"
                className="inline-flex items-center text-gray-600 hover:text-black transition-colors mb-6 cursor-pointer"
              >
                <i className="ri-arrow-left-line mr-2"></i>
                Voltar para home
              </Link>
              <h1 className="text-5xl font-bold text-black mb-4">Política de Privacidade</h1>
              <p className="text-gray-600">Última atualização: Janeiro de 2025</p>
            </div>

            <div className="prose prose-lg max-w-none">
              <h2 className="text-3xl font-bold text-black mb-4 mt-12">1. Informações que coletamos</h2>
              <p className="text-gray-700 leading-relaxed mb-6">
                A Bravia Group coleta informações que você nos fornece diretamente, como nome, email, telefone e outras informações de contato quando você preenche formulários em nosso site, entra em contato conosco ou manifesta interesse em nossos projetos.
              </p>

              <h2 className="text-3xl font-bold text-black mb-4 mt-12">2. Como usamos suas informações</h2>
              <p className="text-gray-700 leading-relaxed mb-4">Utilizamos as informações coletadas para:</p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-6">
                <li>Responder suas solicitações e dúvidas</li>
                <li>Fornecer informações sobre nossos projetos e oportunidades de investimento</li>
                <li>Enviar atualizações e comunicações relevantes</li>
                <li>Melhorar nossos serviços e experiência do usuário</li>
                <li>Cumprir obrigações legais e regulatórias</li>
              </ul>

              <h2 className="text-3xl font-bold text-black mb-4 mt-12">3. Compartilhamento de informações</h2>
              <p className="text-gray-700 leading-relaxed mb-6">
                Não vendemos, alugamos ou compartilhamos suas informações pessoais com terceiros para fins de marketing. Podemos compartilhar informações apenas quando necessário para prestação de serviços, cumprimento de obrigações legais ou com seu consentimento explícito.
              </p>

              <h2 className="text-3xl font-bold text-black mb-4 mt-12">4. Segurança</h2>
              <p className="text-gray-700 leading-relaxed mb-6">
                Implementamos medidas de segurança técnicas e organizacionais para proteger suas informações pessoais contra acesso não autorizado, alteração, divulgação ou destruição.
              </p>

              <h2 className="text-3xl font-bold text-black mb-4 mt-12">5. Seus direitos</h2>
              <p className="text-gray-700 leading-relaxed mb-4">Você tem o direito de:</p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-6">
                <li>Acessar suas informações pessoais</li>
                <li>Corrigir informações incorretas ou incompletas</li>
                <li>Solicitar a exclusão de suas informações</li>
                <li>Opor-se ao processamento de suas informações</li>
                <li>Retirar seu consentimento a qualquer momento</li>
              </ul>

              <h2 className="text-3xl font-bold text-black mb-4 mt-12">6. Cookies</h2>
              <p className="text-gray-700 leading-relaxed mb-6">
                Utilizamos cookies e tecnologias similares para melhorar sua experiência em nosso site, analisar o tráfego e personalizar conteúdo. Você pode controlar o uso de cookies através das configurações do seu navegador.
              </p>

              <h2 className="text-3xl font-bold text-black mb-4 mt-12">7. Contato</h2>
              <p className="text-gray-700 leading-relaxed mb-6">
                Para exercer seus direitos ou esclarecer dúvidas sobre esta política de privacidade, entre em contato conosco através do email contato@braviagroup.com ou pelo telefone +1 (813) 555-0100.
              </p>

              <div className="bg-beige-50 rounded-2xl p-8 mt-12">
                <p className="text-gray-700 leading-relaxed">
                  Esta política de privacidade pode ser atualizada periodicamente. Recomendamos que você revise esta página regularmente para se manter informado sobre como protegemos suas informações.
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
